export const isArray = x => (
  Array.isArray(x)
)
